import { LoyaltyHistory } from 'pages/loyalty/loyalty-history/loyalty-history';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';

export default function HistoryTab() {
  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyHistory />
    </>
  );
}
